export const environment = {
  production: false,
  version: '1.0.2',
  firebase: {
    apiKey: 'AIzaSyATEo7NmBSlJdprl2dr0UD0EqKQ7UyHfQc',
    authDomain: 'sports-management-62e5e.firebaseapp.com',
    projectId: 'sports-management-62e5e',
    storageBucket: 'sports-management-62e5e.firebasestorage.app',
    messagingSenderId: '1054951838742',
    appId: '1:1054951838742:web:9374d075914325c9f25137',
    measurementId: 'G-BX7RWJGFHL',
  },
  sentryEnvironment: 'development', // Sentry `environment` (tenant)
  memberPortalBaseUrl: 'http://localhost:4201',
  supportHub: { role: 'master' as const },
};
